import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles } from "@mui/styles";
import { AppBar, Box, Switch, Tab, Tabs, Typography } from "@mui/material";
import HouseKeepingGrid from "./HouseKeepingGrid";
import StaffAssignment from "./StaffAssignment";
import HouseKeepingCharter from "./HouseKeepingCharter";
import OutOfOrderReport from "./OutOfOrderReport";
import DeniedAccess from "../AccessControl/Views/DeniedAccess";
import * as BsIcons from "react-icons/bs";
import { connect, useSelector } from "react-redux";
import {
  AMPLITUDE_KEY,
  ENV,
} from "../CalendarPage/constants/AmplitudeConstants";
import amplitude from "amplitude-js";
import ClickAwayListenerHelper from "../../Utils/ClickAwayListenerHelper";
import { Button, Modal, ModalBody, ModalTitle } from "react-bootstrap";
import "../CTA/Views/ViewBookingModal.css";
import { useTranslation } from "react-i18next";
import i18n from "../../modules/Auth/pages/i18n";
import { handleSpringDataRequest } from "../../api";
import PaymentModal from "../AccessControl/PaymentModal";
import useAccessControl from "../../../hooks/useAccessControl";
import { GLOBAL_FEATURES } from "../../Utils/CONST";
import SettingsIcon from "@mui/icons-material/Settings";
import HouseKeepingCharter2 from "./HouseKeepingCharter2";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
}));

function HouseKeeping(props) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);
  const { canRead } = useAccessControl();
  const [value, setValue] = React.useState(0);
  const [subUser, setsubUser] = useState(
    props?.data?.accessControl?.ADMINRIGHTS
  );

  // console.log("subuser : ", subUser);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const [roomAssignments, setroomAssignments] = useState(false);
  const openRoomAssignment = () => {
    setroomAssignments(true);
  };

  const hideRoomAssignment = () => {
    setroomAssignments(false);
  };

  const [outOfOrderModal, setOutOfOrderModal] = useState(false);
  const openOutOfOrderModal = () => {
    setOutOfOrderModal(true);
  };

  const hideOutOfOrderModal = () => {
    setOutOfOrderModal(false);
  };

  //Amplitude check on HouseKeeping page
  const amplitudeEventProperties = {
    hotel_id: props?.data?.hotelId,
    environment: ENV,
    email: props.data?.accessControl?.email,
    role: props.data?.accessControl?.ADMINRIGHTS,
  };

  /* useEffect(() => {
    amplitude.getInstance().init(AMPLITUDE_KEY, props.data?.hotelId, {
      saveEvents: true,
      includeUtm: true,
      includeReferrer: true,
    });
    amplitude
      .getInstance()
      .identify(
        new amplitude.Identify()
          .set("hotel_id", props.data?.hotelId)
          .set("email", props.data?.accessControl?.email)
          .set("role", props.data?.accessControl?.ADMINRIGHTS)
      );
    amplitude
      .getInstance()
      .logEvent("HOUSEKEEPING PAGE LOADED", amplitudeEventProperties);
  }, []); */

  const [checked, setChecked] = useState(false);
  const [curentState, setcurentState] = useState("");

  const handleChanges = (event) => {
    setcurentState("");
    setChecked(event.target.checked);
  };

  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const closePaymentModal = () => {
    setShowPaymentModal(false);
  };
  const [paymentAmount, setpaymentAmount] = useState(0);
  const [daysDiff, setdaysDiff] = useState(0);

  const [finalDate, setfinalDate] = useState(new Date());

  useEffect(() => {
    if (
      localStorage.getItem("mainGroupId") &&
      localStorage.getItem("mainGroupId") !== undefined &&
      localStorage.getItem("mainGroupId") !== null
    ) {
      handleSpringDataRequest(
        `web-api/get-payment-dues-amount?groupId=${localStorage.getItem(
          "mainGroupId"
        )}`
      ).then((res) => {
        if (
          res.pendingAmount < 0 &&
          Number(res.daysDiff) >= 15 &&
          Number(res.daysDiff) <= 30 &&
          res.showBanner === "YES"
        ) {
          setpaymentAmount(res.pendingAmount);
          setShowPaymentModal(true);
          setdaysDiff(Number(res.daysDiff));
          setfinalDate(res.date);
        }
      });
    }
  }, [localStorage.getItem("mainGroupId")]);

  return (
    <div>
      {JSON.parse(props?.data?.accessControl?.user_feature_map?.HouseKeeping)
        .read !== "YES" ? (
        <DeniedAccess />
      ) : (
        <div className="houseKeepingWrapper">
          <Modal
            show={roomAssignments}
            onHide={props.hide}
            dialogClassName={"myModalBody12"}
            // animation={false}
            contentClassName={"myModalContent"}
          >
            <ModalTitle>
              <div style={styles.titleAdjustment}>
                <Button variant="white" onClick={hideRoomAssignment}>
                  {" "}
                  X{" "}
                </Button>
              </div>
            </ModalTitle>
            <ModalBody>
              <StaffAssignment selectedLanguage={props.selectedLanguage} />
            </ModalBody>
          </Modal>
          <Modal
            show={outOfOrderModal}
            onHide={props.hide}
            dialogClassName={"myModalBody12"}
            // animation={false}
            contentClassName={"myModalContent"}
          >
            <ModalTitle>
              <div style={styles.titleAdjustment}>
                <Button variant="white" onClick={hideOutOfOrderModal}>
                  {" "}
                  X{" "}
                </Button>
              </div>
            </ModalTitle>
            <ModalBody>
              <OutOfOrderReport selectedLanguage={props.selectedLanguage} />
            </ModalBody>
          </Modal>
          {canRead(GLOBAL_FEATURES.HKSupervisor) && (
            <div className="d-flex justify-content-between">
              {props?.hotelType !== "ISHA" &&
                subUser?.toLowerCase() === "subuser" && (
                  <div className="d-flex mb-4 align-items-center">
                    <h4
                      className="mr-2 mb-0"
                      style={{
                        fontSize: "1.5rem",
                        lineHeight: "2rem",
                        fontWeight: 600,
                      }}
                    >
                      {t("Housekeeping")}
                    </h4>
                    {/* <Switch checked={checked} onChange={handleChanges} /> */}
                  </div>
                )}
              {props?.hotelType === "ISHA" &&
                subUser?.toLowerCase() !== "subuser" && (
                  <div className="d-flex mb-4 align-items-center">
                    <h4
                      className="mr-2 mb-0"
                      style={{
                        fontSize: "1.5rem",
                        lineHeight: "2rem",
                        fontWeight: 600,
                      }}
                    >
                      {t("Housekeeping")}
                    </h4>
                    {/* <Switch checked={checked} onChange={handleChanges} /> */}
                  </div>
                )}
              {props?.hotelType !== "ISHA" &&
                ["admin", "subadmin"].includes(subUser?.toLowerCase()) && (
                  <div className="d-flex mb-4 align-items-center">
                    <h4
                      className="mr-2 mb-0"
                      style={{
                        fontSize: "1.5rem",
                        lineHeight: "2rem",
                        fontWeight: 600,
                      }}
                    >
                      {t("Housekeeping")}
                    </h4>
                    {/* <Switch checked={checked} onChange={handleChanges} /> */}
                  </div>
                )}

              <div className="bulkMarkActionButtonWrapper">
                <ClickAwayListenerHelper
                  btnClassName="bulkMarkActionButton"
                  clickAwayButtonName={<SettingsIcon size="25" color="black" />}
                  content={
                    <div className="actionBtns">
                      {props?.hotelType !== "ISHA" &&
                        subUser?.toLowerCase() === "subuser" && (
                          <button
                            className="actionBtn"
                            onClick={() => {
                              // setcurentState("room_assignment");
                              openRoomAssignment();
                            }}
                          >
                            {t("Room Assignment")}
                          </button>
                        )}
                      {props?.hotelType === "ISHA" &&
                        subUser?.toLowerCase() !== "subuser" && (
                          <button
                            className="actionBtn"
                            onClick={() => {
                              // setcurentState("room_assignment");
                              openRoomAssignment();
                            }}
                          >
                            {t("Room Assignment")}
                          </button>
                        )}
                      {props?.hotelType !== "ISHA" &&
                        ["admin", "subadmin"].includes(
                          subUser?.toLowerCase()
                        ) && (
                          <button
                            className="actionBtn"
                            onClick={() => {
                              // setcurentState("room_assignment");
                              openRoomAssignment();
                            }}
                          >
                            {t("Room Assignment")}
                          </button>
                        )}

                      {props?.hotelType !== "ISHA" &&
                        subUser?.toLowerCase() === "subuser" && (
                          <button
                            className="actionBtn"
                            onClick={() => {
                              // setcurentState("Out_of_order");
                              openOutOfOrderModal();
                            }}
                          >
                            {t("Out Of Order Report")}
                          </button>
                        )}
                      {props?.hotelType === "ISHA" &&
                        subUser?.toLowerCase() !== "subuser" && (
                          <button
                            className="actionBtn"
                            onClick={() => {
                              // setcurentState("Out_of_order");
                              openOutOfOrderModal();
                            }}
                          >
                            {t("Out Of Order Report")}
                          </button>
                        )}
                      {props?.hotelType !== "ISHA" &&
                        ["admin", "subadmin"].includes(
                          subUser?.toLowerCase()
                        ) && (
                          <button
                            className="actionBtn"
                            onClick={() => {
                              // setcurentState("Out_of_order");
                              openOutOfOrderModal();
                            }}
                          >
                            {t("Out Of Order Report")}
                          </button>
                        )}
                    </div>
                  }
                  right=".5px"
                />
              </div>
            </div>
          )}
          {!checked && (
            <HouseKeepingCharter2 selectedLanguage={props.selectedLanguage} />
          )}
          {checked && (
            <HouseKeepingGrid selectedLanguage={props.selectedLanguage} />
          )}
          {/* {curentState === "Out_of_order" && <OutOfOrderReport />} */}
          {/* {curentState === "room_assignment" && <StaffAssignment />} */}

          {/* <AppBar position="static" className="appBar">
            <Tabs
              value={value}
              onChange={handleChange}
              className="houseKeepingTabsWrapper"
              indicatorColor="secondary"
              //   textColor="primary"
              //   variant="fullWidth"
              //   aria-label="full width tabs example"
            >
              <Tab
                label="HouseKeeping Charter"
                {...a11yProps(0)}
                className="houseKeepingTab"
              />

              {props?.hotelType !== "ISHA" &&
                subUser?.toLowerCase() === "subuser" && (
                  <Tab
                    label="Housekeeping"
                    {...a11yProps(1)}
                    className="houseKeepingTab"
                  />
                )}
              {props?.hotelType === "ISHA" &&
                subUser?.toLowerCase() !== "subuser" && (
                  <Tab
                    label="Housekeeping"
                    {...a11yProps(1)}
                    className="houseKeepingTab"
                  />
                )}
              {props?.hotelType !== "ISHA" &&
                subUser?.toLowerCase() === "admin" && (
                  <Tab
                    label="Housekeeping"
                    {...a11yProps(1)}
                    className="houseKeepingTab"
                  />
                )}
              {props?.hotelType !== "ISHA" &&
                subUser?.toLowerCase() === "subuser" && (
                  <Tab
                    label="Out Of Order Report"
                    {...a11yProps(2)}
                    className="houseKeepingTab"
                  />
                )}
              {props?.hotelType === "ISHA" &&
                subUser?.toLowerCase() !== "subuser" && (
                  <Tab
                    label="Out Of Order Report"
                    {...a11yProps(2)}
                    className="houseKeepingTab"
                  />
                )}
              {props?.hotelType !== "ISHA" &&
                subUser?.toLowerCase() === "admin" && (
                  <Tab
                    label="Out Of Order Report"
                    {...a11yProps(2)}
                    className="houseKeepingTab"
                  />
                )}
              {props?.hotelType !== "ISHA" &&
                subUser?.toLowerCase() === "subuser" && (
                  <Tab
                    label="Room Assignment"
                    {...a11yProps(3)}
                    className="houseKeepingTab"
                  />
                )}
              {props?.hotelType === "ISHA" &&
                subUser?.toLowerCase() !== "subuser" && (
                  <Tab
                    label="Room Assignment"
                    {...a11yProps(3)}
                    className="houseKeepingTab"
                  />
                )}
              {props?.hotelType !== "ISHA" &&
                subUser?.toLowerCase() === "admin" && (
                  <Tab
                    label="Room Assignment"
                    {...a11yProps(3)}
                    className="houseKeepingTab"
                  />
                )}
            </Tabs>
          </AppBar>
          <SwipeableViews
            // axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} className="tabsContent">
              <HouseKeepingCharter />
            </TabPanel>
            <TabPanel value={value} index={1} className="tabsContent">
              <HouseKeepingGrid />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <OutOfOrderReport />
            </TabPanel>
            <TabPanel value={value} index={3} className="tabsContent">
              <StaffAssignment />
            </TabPanel>
          </SwipeableViews> */}
        </div>
      )}
      <PaymentModal
        showPaymentModal={showPaymentModal}
        paymentAmount={paymentAmount}
        closePaymentModal={closePaymentModal}
        days={daysDiff}
        finalDate={finalDate}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel, hotelType: state.auth.hotelType };
}
export default connect(mapStateToProps)(HouseKeeping);

const styles = {
  titleAdjustment: {
    display: "flex",
    justifyContent: "space-between",
  },
};
